import { connect } from 'react-redux';
import LiveOrderPage from './LiveOrderPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { getLiveOrderData, rowClick, rework } from 'src/actions/liveOrderAction';
import { downloadURL } from 'src/actions/completeOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';

export const mapStateToProps = (state: AppState) => {
    return {
        liveOrderData: state.liveOrder.liveOrderData
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getLiveOrderData);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
            dispatch(getLiveOrderData);
        },
        reload: () => {
            dispatch(getLiveOrderData);
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Initial Scan'));
        },
        submitCancel: (column: Object) => {
            dispatch(rework(column, 'live'));
        },
    };
};

const LiveOrderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LiveOrderPage);

export default LiveOrderContainer;



// WEBPACK FOOTER //
// ./src/components/liveOrderPage/LiveOrderPageContainer.tsx